import { render } from "./HeaderSite.vue?vue&type=template&id=672ba6ec&scoped=true"
import script from "./HeaderSite.vue?vue&type=script&lang=js"
export * from "./HeaderSite.vue?vue&type=script&lang=js"

import "./HeaderSite.vue?vue&type=style&index=0&id=672ba6ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672ba6ec"]])

export default __exports__